import { route } from '@bikemap/js/api'
import { context } from '@bikemap/js/services'

const routeId = context.page('routeId')

/**
* Promise of an initial route API call.
* */
const routeResult = route.readDetailed(routeId)

export async function getRoute() {
    return (await routeResult).route
}

export async function getUser() {
    return (await routeResult).user
}
